<template>
  <div class="searchboxwrapper"
    v-clickOutside="clickedOutside">
    <a class="dropdownbtn"
      :style="{ '--border-color': bordercolor }"
      :class="{'end': caretend == true, 'disabled': disabled }"
      data-toggle="grauDropDown"
      @click="toggleCombo">
        <i class="fa" :class="chevronClass"></i>
        <input ref="inputbox"
          class="value"
          autofocus 
          :value="filter"
          @input="setFilterValue"
          :placeholder="defaultmsg" 
          :disabled="disabled"/>
    </a>
    <Dropdown
      :isOpen="isOpen"
      :show="filteredOptions.length > 0 && isOpen"
      :droppaneClass="droppaneClass"
      :dropClass="dropClass"
      :droppaneStyle="droppaneStyle">
      <Option
        :optionClass="optionClass"
        :option="option"
        :isActive="isActive(option)"
        :optionsStyle="optionsStyle"
        :key="option.title"
        v-for="option in filteredOptions"
        @click="handleInput(option)" />
    </Dropdown>
  </div>
</template>

<script>
const clickOutside = {
  beforeMount: (el, binding) => {
    el.clickOutsideEvent = event => {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        binding.value();
      }
    };
    document.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted: el => {
    document.removeEventListener("click", el.clickOutsideEvent);
  },
};

import { ref, computed, watch } from "vue";
import Option from './option.vue';
import Dropdown from './dropdown.vue';

export default {
  name: "ComboSearch",
  props:[
    "modelValue",
    "defaultmsg",
    "options",
    "caretend",
    "bordercolor",
    "optionsStyle",
    "droppaneStyle",
    "droppaneClass",
    "dropClass",
    "optionClass",
    "closeOnClickOutside",
    "disabled"
  ],
  emits:[
    "update:modelValue",
    "update:toggleCombo",
    "update:closeCombo",
    "clickOutside"
  ],
  components:{
    Option,
    Dropdown
  },
  setup(props, { emit }){

    const filter = ref(props.modelValue?.label ?? '');
    const setFilterValue = (e) => {
      filter.value = e.target.value;
    }

    watch(() => props.modelValue, newval => {
      filter.value = newval?.label ?? "";
    })

    const filteredOptions = computed(() => {
      const filterWords = filter.value.toLowerCase().split(" ");
      return props.options.filter(option =>
        filterWords.every(word => option.label.toLowerCase().includes(word))
      );
    })

    const isOpen = ref(false);
    const lineCountRefs = ref([]);

    const chevronClass = computed(() => {
      if(isOpen.value){
        return 'fa-chevron-up';
      }
      return props.disabled ? 'fa-chevron-down disabled' : 'fa-chevron-down';
    })

    const borderColor = computed(() => props.bordercolor || 'black');
    const hasBorderColor = computed(() => !!props.bordercolor);

    const isSelectingDifferentOption = option => option?.value != props.modelValue?.value

    const handleInput = option => {
      const updatedOption = isSelectingDifferentOption(option) ? option : null;
      filter.value = updatedOption ? updatedOption.label : '';
      isOpen.value = false;
      emit('update:modelValue', updatedOption);
      emit('update:closeCombo');
    }

    const isActive = option => props.modelValue != null && option?.value == props.modelValue?.value;

    const toggleCombo = () => {
      if(props.options.length > 0){
        isOpen.value = !isOpen.value;
        if(isOpen.value) { 
          filter.value = '';
        }
      }
    }

    const clickedOutside = () => {
      if(isOpen.value){
        filter.value = props.modelValue?.label ?? ''
      }
      isOpen.value = false;
      emit("clickOutside");
    }




    return {
      setFilterValue,
      clickedOutside,
      toggleCombo,
      isActive,
      handleInput,
      filter,
      filteredOptions,
      isOpen,
      lineCountRefs,
      chevronClass,
      borderColor,
      hasBorderColor
    }

  },
  watch: {
    /*
    'isOpen': function(newVal){
      if(newVal){
        this.$nextTick(()=>this.checkLineCounts());
      }
    }*/
  },
  updated(){
    if(this.isOpen){
      this.$nextTick(()=>this.$refs.inputbox.focus());
    }
  },
  methods:{
    getRefForOption(option){
      return `option-${option.value}`;
    },
    checkLineCounts() {
      const lineHeight = 25; // Assuming a line-height of 20px, adjust as needed
      /*this.filteredOptions.forEach(el => {
        const domel = this.$refs[this.getRefForOption(el)][0];
        if(domel.clientHeight > 35){
          domel.classList.add('two-or-more-lines');
        }else{
          domel.classList.remove('two-or-more-lines');
        }
      })*/
    }
  },
  directives:{
    clickOutside
  }
}
</script>

<style>
:root{
  --input-color: #6a6868; 
  --placeholder-color: var(--default-placeholder-color);
  --arrow-color: var(--default-arrow-color);
  --placeholder-disabled-color: var(--default-placeholder-disabled-color);
  --arrow-disabled-color: var(--default-arrow-disabled-color);
}
</style>

<style scoped>
.dropdownbtn,
.dropdownbtn:hover {
  display: inline-flex;
  margin-left: 0;
  cursor: pointer;
  color: #333333;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: "Montserrat Light",serif;
  font-size: 16px;
  border: 0;
}

.dropdownbtn::after{
  content: '';
  position: absolute;
  height: 1.45px;
  left:0;
  right: 0;
  bottom: -12px;
  background-color: #0a0a0a;
}

/*a hydra têm uma definição que altera o box-sizing por isso é necessário isto aqui*/
.searchboxwrapper * {
  box-sizing: border-box !important;
}

.searchboxwrapper {
  position: relative;
}

@media (max-width: 1024px) {
  .searchboxwrapper {
    margin-bottom: 30px;
  }
}

@media (max-width: 767px) {
  .searchboxwrapper {
    margin-bottom: 10px;
  }
}


.value {
  margin-left: 50px;
  display: inline-block;
  cursor: pointer;
  color: var(--input-color);
  font-family: "PT Sans Italic";
  display: inline-block;
  text-overflow: ellipsis;
  font-size: 24px;
  cursor: pointer;
  color: #333333;
}

.value::placeholder{
  color: var(--placeholder-color);
}

.disabled .value::placeholder{
  color: var(--placeholder-disabled-color);
}

input.value{
  border: 0;
  background: transparent;
  display: flex;
  flex: 1 1 100%;
  width: 100%;
}

input.value:focus,
input.value:focus-visible{
  outline: none !important;
  box-shadow: none !important;
}

.dropdownbtn i {
  position: absolute;
  font-size: 17px;
  color: var(--arrow-color);
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
}

.dropdownbtn i.disabled {
  color: var(--arrow-disabled-color);
}

.dropdownbtn.end i{
  position: absolute;
  right: 0;
}

.dropdownbtn.end .value,
.dropdownbtn.end .result{
  padding-left: 25px;
}

#grauDropDown{
  top: 46px;
}

@media (max-width: 1200px) {
  .dropdownbtn i {
    margin-right: 15px;
    font-size: 17px;
  }
}


@media (min-width: 768px) and (max-width: 1024px) {
  .value {
    font-size: 20px;
  }
}

@media (max-width: 767px) {
  .value {
    font-size: 16px;
  }

  .dropdownbtn,
  .dropdownbtn:hover {
    font-family: "Montserrat Light",serif;
    font-size: 12px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .dropdownbtn::after{
    bottom: 0px;
  }

  .cicloremove{
    right: -7px;
    font-size: 17px;
  }

  input {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .dropdownbtn.end i {
    padding-top: 6px;
  }

}
</style>